
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legals/privacy",
      function () {
        return require("private-next-pages/legals/privacy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legals/privacy"])
      });
    }
  